import $ from "jquery";

export default () => {
    var addressId = null;

    $('#form-cart-contact').on('change', function() {
        var $value = $(this).find('[name="thelia_order_delivery[delivery-address]"]:checked').val();
                
        if(typeof $value === 'undefined') {
            $('#search-delivery-date').addClass('disabled');
        }
        else {
            $('#search-delivery-date').removeClass('disabled');
        }
    })
    $('#search-delivery-date').on('click', function(e) {
        e.preventDefault();
        
        addressId = $('#form-cart-contact').find('[name="thelia_order_delivery[delivery-address]"]:checked').val();
        
        if(addressId) {
            window.location.href = $(this).attr('href')+'&address='+addressId;
        }
    });
}


// WEBPACK FOOTER //
// ./assets/src/js/modules/SelectContactAddress.js